import * as Sentry from '@sentry/react'
import { devLog } from 'utilsTS'

export const SET_USER_DATA = 'USER_SET_DATA'
export const REMOVE_USER_DATA = 'USER_REMOVE_DATA'
export const USER_LOGGED_OUT = 'USER_LOGGED_OUT'
export const USER_NOT_MU_AUTHENTICATED = 'USER_NOT_MU_AUTHENTICATED'

export function setUserData (user) {
  return dispatch => {
    if (user?.userId) {
      Sentry.setUser({
        id: user.userId,
        username: user?.username,
        email: user?.email
      })

      Sentry.setContext('User Details', {
        'Display Name': user?.displayName,
        'Portal role': Array.isArray(user?.role) ? user?.role?.join(', ') : user?.role
      })

      if (user?.displayName) {
        Sentry.setTag('user.displayName', user.displayName)
      }
      if (user?.role) {
        const roleStr = Array.isArray(user.role) ? user.role.join(', ') : user.role
        Sentry.setTag('user.portalRole', roleStr)
      }
    }

    dispatch({
      type: SET_USER_DATA,
      data: user
    })
  }
}

export function userNotAutenticatedForMultiuser () {
  return dispatch => {
    dispatch({
      type: USER_NOT_MU_AUTHENTICATED
    })
  }
}

export function logoutUser () {
  return (dispatch, user) => {
    const SFAuthService = require('app/services/sfAuth/SFAuthService').default
    const conn = SFAuthService.getConnection()

    const handleLogout = () => {
      SFAuthService.logout().then(res => {
        Sentry.setUser(null)
        devLog('logged out')
        dispatch({
          type: USER_LOGGED_OUT
        })
        window.location = '/'
      })
    }

    conn
      .requestPost('/services/apexrest/community/hardLogout', {
        userId: user.userId
      }).then(result => {
        handleLogout()
      }, reject => {
        console.error('Apex logout error', reject)
        handleLogout()
      })
  }
}
